@if (inputElem()?.inputs) {
  <div
    ngbDropdown
    placement="bottom-right top-right"
    [autoClose]="false"
    #dropdown="ngbDropdown"
    (keydown)="keyboardNavigation($event)"
    (focusin)="focusInHandler($event)"
    (focusout)="focusOutHandler($event)"
    (click)="$event.stopPropagation()"
  >
    <div class="form-floating">
      <div
        class="form-control form-control-meta form-control-meta-select h-auto"
        [ngClass]="isLoading() ? 'form-control-meta-readonly' : null"
      >
        <input
          class="position-relative z-1 mb-1"
          [attr.id]="inputElem().name"
          [attr.name]="inputElem().name"
          [name]="inputElem().name"
          [attr.readonly]="isLoading() ? 'readonly' : null"
          autocomplete="off"
          role="combobox"
          aria-autocomplete="both"
          aria-owns="address-input-dropdown"
          [attr.aria-activedescendant]="selectedOption()?.id || null"
          [formControl]="searchInput"
          #searchInputElem
        />
        @if (inputElem().labelKey) {
          <label [attr.for]="inputElem().name" [translate]="inputElem().labelKey" class="form-label"></label>
        }
        <div
          class="border-end border-gray-500 position-absolute pr-1"
          [ngClass]="{ 'd-none': !searchInput.value }"
          style="top: 50%; right: 40px; transform: translateY(-50%)"
        >
          <mwe-button
            [isIconBtn]="true"
            size="xs"
            [category]="'secondary'"
            [color]="'transparent'"
            (clicked)="searchInput.patchValue(''); searchInputElement?.nativeElement?.focus()"
            title="Suchbegriff löschen"
          >
            <i class="fas fa-close" aria-hidden="true" style="font-size: 1.25rem"></i>
          </mwe-button>
        </div>
        @if (pills().length) {
          <div class="row g-2">
            @for (pill of pills(); track pill.name) {
              <div class="col-auto">
                <mwe-button
                  size="xs"
                  category="secondary"
                  color="blue"
                  appendIconClass="fas fa-close"
                  [labelKey]="pill.labelKey"
                  (clicked)="onPillClick($event, pill.name)"
                  [disabled]="isLoading() || null"
                />
              </div>
            }
          </div>
        }
      </div>
    </div>
    @if (inputElem()?.inputs.length > 0) {
      <div class="dropdown-menu" id="address-input-dropdown" ngbDropdownMenu #dropdownElement role="listbox">
        @for (radio of filteredOptions(); track $index) {
          <label
            [attr.id]="radio.name"
            class="dropdown-item p-3 mb-0"
            [attr.data-option-index]="$index"
            [attr.aria-label]="radio.labelKey"
            [attr.aria-selected]="parentForm().controls[radio.name].value"
            role="option"
          >
            <div class="row g-12px flex-grow-1">
              @if (radio.iconClass) {
                <div class="col-auto align-self-center">
                  <i class="{{ radio.iconClass }}" style="font-size: 1.5rem"></i>
                </div>
              }
              <div class="col">
                <p class="mb-0 font-size-16">{{ radio.labelKey }}</p>
                <p class="mb-0">{{ radio.sublineLabelKey }}</p>
              </div>
              <div class="col-auto align-self-center">
                <div class="dropdown-item-check">
                  <input
                    [attr.data-test]="getUniqueId($index)"
                    [attr.id]="getUniqueId($index)"
                    [formControl]="parentForm().controls[radio.name]"
                    [attr.name]="radio.name"
                    [disabled]="isLoading()"
                    tabindex="-1"
                    class="form-check-input d-none"
                    type="checkbox"
                  />
                  <i class="fas fa-check font-size-16"></i>
                </div>
              </div>
            </div>
          </label>
        }
      </div>
    }
  </div>
}
